

import React, { useState } from "react";
import {
  Button,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Checkbox,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from "react-router-dom";
import { useStyle } from "../style";
import axios from 'axios'; // Ensure axios is imported
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { useDispatch } from "react-redux";
import moment from "moment";

const ApproveModal = ({ tableHeadData, flattenedData, setOpen, data, handleTransferApproved,cust,handleSalesReturn }) => {
  const classes = useStyle();
  const location = useLocation();
  const [selectedRows, setSelectedRows] = useState([]);
  const outletId = localStorage.getItem('outlet_id')
  const dispatch = useDispatch();
  // Handle selection of all checkboxes
  console.log(data,"custcustcust");
  
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = flattenedData.map((n) => n.id);
      setSelectedRows(newSelecteds);
    } else {
      setSelectedRows([]);
    }
  };

  // Handle selection of a single checkbox
  const handleClick = (event, id) => {
    const selectedIndex = selectedRows.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedRows, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedRows.slice(1));
    } else if (selectedIndex === selectedRows.length - 1) {
      newSelected = newSelected.concat(selectedRows.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedRows.slice(0, selectedIndex),
        selectedRows.slice(selectedIndex + 1)
      );
    }

    setSelectedRows(newSelected);
  };

  // Check if a row is selected
  const isSelected = (id) => selectedRows.indexOf(id) !== -1;

  // Handle approval action
  const handleApprove = () => {
    const selectedData = flattenedData.filter((row) => selectedRows.includes(row.id));
    const payload = selectedData.map((row) => ({
      docno: row.docno,
      prodid: row.prodid,
      outlet_id: cust.id,
      barcode: row.barcode,
      date: row.date,
    }));

    axios.post('/v1/wastage/outlet/approve', payload)
      .then((res) => {
        setOpen(false);
          dispatch(setSnackbar(true, "success", "approved successfully!"));
          setSelectedRows([]);
          handleSalesReturn()
      })
      .catch((err) => {
        const errorMessage =
          err.response?.data?.errors?.[0]?.message || "Something went wrong";
            dispatch(setSnackbar(true, "error", errorMessage)); // Show error message
        
        console.error("Error approving transfer:", err);
      });
  };
// console.log(isItemSelected,"isItemSelected");

  return (
    <Grid sx={{ backgroundColor: "#fff", padding: "10px", maxHeight: "500px", overflowY: "auto" }}>
      <div className="flex justify-between">
        {data && (
          <Grid className="flex my-1" style={{ flexDirection: "column" }}>
            <Typography>Date: <strong>{data.documentDate}</strong></Typography>
          </Grid>
        )}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            sx={{
              borderRadius: '120px',
              fontSize: 10,
              marginRight: '8px',
              '&.Mui-disabled': {
                backgroundColor: 'gray', // Set your desired disabled background color
                color: 'white', // Set your desired disabled text color
              },
            }}
            onClick={handleApprove}
            disabled={data && data.approve === "Approved"}          >
            Approve
          </Button>
          <IconButton size="small" sx={{ marginBlockEnd: 2 }} onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </div>
      </div>
      <TableContainer className={classes.tblRoot}>
        <Table className={classes.table}>
          <TableHead className={classes.tblHeader} sx={{ backgroundColor: "black", color: "#fff" }}>
            <TableRow className={classes.tablrow} sx={{ color: "#fff" }}>
              <TableCell padding="checkbox">
                <Checkbox
                  color="primary"
                  indeterminate={selectedRows.length > 0 && selectedRows.length < flattenedData.length}
                  checked={flattenedData.length > 0 && selectedRows.length === flattenedData.length}
                  onChange={handleSelectAllClick}
                />
              </TableCell>
              {tableHeadData.map((item) => (
                <TableCell className={classes.tblCell} sx={{ color: "#fff" }} key={item.id}>{item.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {flattenedData.map((val) => {
              const isItemSelected = isSelected(val.id);
              console.log(isItemSelected,"isItemSelected");
              const isApproved = val.is_approved === 1;
              return (
                <TableRow
                  className={classes.tablrow}
                  key={val.id}
                  onClick={(event) => handleClick(event, val.id)}
                  role="checkbox"
                  aria-checked={isItemSelected}
                  selected={isItemSelected}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      color="primary"
                      // checked={isItemSelected}
                     
                      checked={isApproved || isItemSelected}
                      // disabled={isApproved} // Disable checkbox if approved
                      onChange={(event) => handleClick(event, val.id)} // Ensure onChange is handled
                    />
                  </TableCell>
                  <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{val.sNo}</TableCell>
                  <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{val.docno}</TableCell>
                  <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{ moment(val.date).format("DD-MM-YYYY")}</TableCell>
                  <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{val.proName}</TableCell>
                  {/* <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{val.pro_code}</TableCell> */}
                  <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{val.barcode}</TableCell>
                  <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{val.amount}</TableCell>
                  <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{val.rate}</TableCell>
                  <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{val.qty}</TableCell>
                  {/* <TableCell sx={{ borderLeft: "1px solid #ccc !important" }}>{val.purchase_rate}</TableCell> */}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default ApproveModal;
